if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        // this.form.addEventListener('submit', this.showMobileNumberPopup.bind(this));
        this.form.addEventListener('submit', (evt) => {
          evt.preventDefault();
          this.onSubmitHandler();
        });
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.loadingEffectEl = document.querySelector(".loading-overlay-effect");
        this.addOnValidation = false;

        if (document.querySelector('cart-drawer')) this.submitButton?.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler() {
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.addOnValidation = false;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.loadingEffectEl.classList.add("active");
        document.body.classList.add("overflow-hidden");
        this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (this.submitButton.getAttribute('add-ons')) {
              this.addOnValidation = true;
              // Call the async function
              this.addOnProduct.call(this)
                .then(() => {
                  console.log('Add on product added to cart!');
                })
                .catch((err) => {
                  console.error('Error in add on product add to cart:', err);
                });
            } else {
              this.addOnValidation = false;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.renderSkeletonCartContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              if (!this.addOnValidation) {
                this.renderSkeletonCartContents(response);
              }
            }
            const atcFileInput = document.querySelector("#drawer-file-input");
            if (atcFileInput && atcFileInput.value !== "") {
              atcFileInput.value = "";
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (!this.addOnValidation) {
              this.resetLoadingState();
            }
          });
      }

      showMobileNumberPopup(evt) {
        evt.preventDefault();
        const mobileNumberPopup = document.getElementById("PopupModal-capture-mobile");

        if(mobileNumberPopup){
          this.storedMobileNumber = this.getMobileNumberWithExpiry('userMobileNumber');
          this.expiry = mobileNumberPopup.dataset.expiryDays;
  
          if (this.storedMobileNumber) {
            this.onSubmitHandler();
            this.sendOrderDetailsToGoogleSheet(this.storedMobileNumber);
            return;
          }
  
          if (mobileNumberPopup) {
            mobileNumberPopup.setAttribute("open", true);
            const mobileNumber = mobileNumberPopup.querySelector("#user-mobile-number");
            const submitButton = mobileNumberPopup.querySelector("#submit-mobile-number");
            const errorMessage = mobileNumberPopup.querySelector(".mobile-number-input-error");
  
            mobileNumber.addEventListener('input', () => {
              errorMessage.classList.add('hidden');
            });
  
            submitButton.onclick = () => {
              errorMessage.classList.add('hidden');
              const mobileNumberValue = mobileNumber.value.trim();
              const mobileNumberPattern = /^[6-9]\d{9}$/;
              if (mobileNumberPattern.test(mobileNumberValue)) {
                mobileNumberPopup.removeAttribute("open");
                this.setMobileNumberWithExpiry('userMobileNumber', mobileNumberValue, this.expiry);
                this.onSubmitHandler();
                this.sendOrderDetailsToGoogleSheet(mobileNumberValue);
              } else {
                errorMessage.classList.remove('hidden');
              }
            };
          }
        }
        else {
          this.onSubmitHandler();
        }
      }

      sendOrderDetailsToGoogleSheet(mobileNumber) {
        const variantId = this.dataset.variantId;
        const productTitle = this.dataset.productTitle;
        const variantPrice = this.dataset.variantPrice;
        const variantSku = this.dataset.variantSku;

        const googleSheetUrl = 'https://script.google.com/macros/s/AKfycbxaFoz-zxotgmsdq5NsqvPF90TI_Zf64uYlD9WrfB0offkPO8RTv8nyf1YN7htUQsNc/exec';

        const data = {
          countryCode: '91',
          mobileNumber: mobileNumber,
          productTitle: productTitle,
          variantId: variantId,
          variantSku: variantSku,
          variantPrice: variantPrice,
          quantity: 1
        };
        fetch(googleSheetUrl, {
          method: 'POST',
          mode: 'no-cors',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        })
        .then(response => {
          console.log('Order details sent to Google Sheet successfully.');
        })
        .catch(error => {
          console.error('Error sending order details to Google Sheet:', error);
        });
      }

      async addOnProduct() {
        this.mainProductId = this.querySelector("[name=id]").value;
        this.timestamp = document.querySelector('drawer-flow #timestamp');

        let bundleData = {
          items: [],
          sections: [
            "cart-drawer",
            "cart-icon-bubble"
          ],
          section_url: `${window.location.pathname}`,
        };

        bundleData.items.push({
          id: parseInt(this.submitButton.getAttribute('add-on-product-id')),
          quantity: 1,
          properties: {
            "add-on-product": true,
            "main-product-id": this.mainProductId,
            "timestamp": this.timestamp.value
          }
        });

        const Bundleconfig = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest"
          },
          body: JSON.stringify(bundleData),
        };

        try {
          const response = await fetch('/cart/add.js', Bundleconfig);

          if (!response.ok) {
            throw new Error(`Error adding add-on product to cart: ${response.statusText}`);
          }

          const parsedState = await response.json();

          this.error = false;
          this.renderSkeletonCartContents(parsedState);
        } catch (error) {
          console.error('Failed to add add-on product to cart:', error);
        } finally {
          this.resetLoadingState();
        }
      }

      renderSkeletonCartContents(parsedState) {
        const sectionsToRender = [
            { id: 'shopify-section-cart-drawer', htmlKey: 'cart-drawer' },
            { id: 'cart-icon-bubble', htmlKey: 'cart-icon-bubble' },
        ];
    
        let allSectionsRendered = true;
    
        sectionsToRender.forEach(section => {
            const sectionHtml = parsedState.sections[section.htmlKey];
            const sectionElement = document.querySelector(`#${section.id}`);
    
            if (sectionHtml && sectionElement) {
                sectionElement.innerHTML = sectionHtml;
            } else {
                allSectionsRendered = false;
            }
        });
    
        if (allSectionsRendered) {
            document.querySelector('cart-drawer').open();
        } else {
            this.resetLoadingState();
            window.location.reload();
        }
      }    

      resetLoadingState() {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.loadingEffectEl.classList.remove("active");
        this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      setMobileNumberWithExpiry(key, value, expiryInDays) {
        const now = new Date();
        const item = {
          value: value,
          expiry: now.getTime() + expiryInDays * 24 * 60 * 60 * 1000
        };
        localStorage.setItem(key, JSON.stringify(item));
      }

      getMobileNumberWithExpiry(key) {
        const itemStr = localStorage.getItem(key);
        if (!itemStr) return null;

        if (!itemStr.startsWith('{')) {
          const mobileNumber = itemStr;

          this.setMobileNumberWithExpiry(key, mobileNumber, this.expiry); // reset expiry
          return mobileNumber;
        }

        try {
          const item = JSON.parse(itemStr);

          if (!item.expiry || Date.now() > item.expiry) {
            localStorage.removeItem(key);
            return null;
          }

          return item.value;
        } catch (e) {
          localStorage.removeItem(key);
          return null;
        }
      }
    }
  );
}
